import { render, staticRenderFns } from "./newCRM.vue?vue&type=template&id=7cb755de"
import script from "./newCRM.vue?vue&type=script&lang=js"
export * from "./newCRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports